import $ from 'jquery';

const $searchTrigger = $('.top-bar-menu__icon.top-bar-menu__icon__search');
const $searchClose = $('.top-bar-menu__icon.top-bar-menu__icon__close');
const $searchInputWrapper = $('.top-bar-menu__search');
const $searchForm = $('.top-bar-menu__search .search-form');
const $searchInput = $searchForm.find('input');


$searchTrigger.on('click', (e) => {
	if ($searchInputWrapper.hasClass('is-active')) {
		$searchForm.submit();
		return;
	}
	$searchInput.focus();
	$searchInputWrapper.toggleClass('is-active');
});

$searchClose.on('click', (e) => {
	$searchInputWrapper.toggleClass('is-active');
});